module.exports = __webpack_public_path__ + "static/img/fs1-1.e8ae3f7.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/SaveFile/fs1-1.png
// module id = 839
// module chunks = 0